const DuasDatas = ({ value1, onChange1, value2, onChange2 }) => {
    return (
        <div className="input-group mb-3">
            <input
                type="date"
                className="form-control me-2"
                value={value1}
                onChange={(e) => onChange1(e.target.value)}
            />
            <input
                type="date"
                className="form-control"
                value={value2}
                onChange={(e) => onChange2(e.target.value)}
            />
        </div>
    );
};
export default DuasDatas;